import { lighten, styled, Table, TableBody, TableCell, TableHead } from "@mui/material";

export const StyledTableBody = styled(TableBody)(({ theme }) => ({
  "& .MuiTableRow-root": {
    // "&:not(:first-of-type)" :{
    "& .MuiTableCell-root:not(:last-of-type)": {
      borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.8)}`,
    },
    // }
  },
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  "& .MuiTableRow-root": {
    "& .MuiTableCell-root": {
      backgroundColor: theme.palette.background.paper,
      "&:not(:last-of-type)": {
        borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.8)}`,
      },
    },
  },
}));

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "isScocialSecurity",
})<{ isSocialSecurity: boolean }>(({ theme, isSocialSecurity }) => ({
  ...(isSocialSecurity && {
    backgroundColor: theme.palette.background.paper,
  }),
}));
